import { withDevtools } from '@angular-architects/ngrx-toolkit';

export const withDevToolsStub: typeof withDevtools = () => store => store;

export const environment = {
  production: true,
  ID_ENDPOINT: 'https://id.lumir.cloud',
  // Хост админки — абсолютный origin, не маршрут: туда фотокласс возвращает админа, чью сессию
  // «войти от имени» продлить нечем (FKS-11956), чтобы она перевыпустила вход в тот же кабинет.
  ADMIN_ENDPOINT: 'https://admin.lumir.cloud',
  GALLERY_ENDPOINT: 'https://gallery.lumir.cloud',
  // Product switcher targets: each surface links to its siblings by absolute origin, never a route.
  FOTOCLASS_ENDPOINT: 'https://fotoklass.lumir.cloud',
  // Непустой адрес включает пункт «Фотобук» в переключателе продуктов всех кабинетов стейджа.
  // На prod адрес пуст: продукт там ещё не запущен (BFF выключен), пункт не показывается.
  PHOTOBOOK_ENDPOINT: 'https://photobook.lumir.cloud',
  // Стейдж — контур, где Фотобук готовят: пункт меню включён. На проде флаг `false`.
  photobookMenuEnabled: true,
  // CRM sections of Studio Manager beside «Маркетинг»; off = the cabinet is «Презентация» and «Заявки» alone.
  studioManagerCrmSections: false,
  // Temporary stage address of the guest gallery; the per-photographer scheme is a separate ticket.
  GALLERY_PUBLIC_ORIGIN: 'https://gallery-public.lumir.cloud',
  PORTFOLIO_PUBLIC_ORIGIN: 'https://portfolio-public.lumir.cloud',
  PORTFOLIO_CABINET_ORIGIN: 'https://portfolio.lumir.cloud',
  FOTOCLASS_ORIGIN: 'https://fotoklass.lumir.cloud',
  // Staging client pages for booking, forms and document links.
  STUDIO_PUBLIC_ENDPOINT: 'https://studio-manager-public.lumir.cloud',
  storeWithDevTools: withDevToolsStub,
  AUTH_REDIRECT_TO: 'https://fotoklass.lumir.cloud/auth/callback',
  AUTH_CALLBACK_ALLOWLIST: [{ protocol: 'https:', host: 'lumir.cloud', includeSubdomains: true, allowAnyPort: false }],
  LANDING_URL: 'https://lumir.cloud/',
  // Непустой адрес включает пункт «Галереи» в переключателе продуктов всех кабинетов стейджа.
  GALLERY_APP_URL: 'https://gallery.lumir.cloud',
  PORTFOLIO_APP_URL: 'https://portfolio.lumir.cloud',
  FOTOCLASS_APP_URL: 'https://fotoklass.lumir.cloud',
  DASHBOARD_APP_URL: 'https://dashboard.lumir.cloud',
  // Staging CRM cabinet (CRM flag on); production keeps it empty until the CRM launch.
  STUDIO_MANAGER_APP_URL: 'https://studio-manager.lumir.cloud',
  allowOnboardingReplay: true,
  disableOnboarding: false,
  openPanel: {
    clientId: '69e29f2a-720c-4d28-82a3-caf5e21fdc5c',
    // Same-origin: the app's nginx forwards `/_m/` to the OpenPanel host — a third-party host is cut by ad blockers.
    apiUrl: '/_m',
  },
  billingEnabled: true,
  vkPixelId: undefined as string | undefined,
  // DSN self-hosted Sentry; пусто — трекинг ошибок выключен.
  sentryDsn: 'https://9e15e05cac70eab6730b6893a831c3ac@sentry.lumir.photo/3' as string | undefined,
  sentryEnvironment: 'stage' as string,
  // Support widget switch: off hides the chat everywhere, even with an origin set.
  supportWidgetEnabled: true as boolean,
  // Origin of the support widget (loader + chat window); empty keeps the widget off.
  SUPPORT_WIDGET_ORIGIN: 'https://support.lumir.cloud' as string,
  singleAlbumAutoRedirect: false,
  demoPhotosEnabled: true,
  // Мост редактора живёт на origin приложения: кука сессии `sameSite: 'lax'` уезжает с upgrade-запросом
  // только к своему же хосту, поэтому адрес относительный, а до сервиса его доводит ingress.
  editorMcpWsUrl: '/ws' as string | undefined,
  /** Jaeger UI of this environment; the journal links a step to its trace. */
  jaegerUrl: undefined as string | undefined,
  /** Persist-гейт нормалайзера photobook.model: 'off' | 'on'; allowlist project ids открывает точечно. */
  photobookPersistEncode: 'on' as string,
  photobookPersistEncodeProjectIds: '' as string,
};
